import { ReactNode } from 'react'

/** Enum of notification variants, i.e. success or warning */
export enum NotificationVariant {
    SHADE = 'shade',
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
}

/** Model used in the state of "notifications" */
export type NotificationModel = {
    id: string
    title?: string
    message: string
    variant: NotificationVariant
    actions?: string
}

/** Options model used to add a new notification (notify) */
export type NotificationsNotifyOptions = {
    id?: string
    message: string
    title?: string
    variant?: NotificationVariant
    actions?: string
}

/** Interface for the Notification components, i.e. <FixedNotification> or <InlineNotification> */
export interface NotificationProps extends React.HTMLAttributes<HTMLDialogElement> {
    id?: string
    title?: string
    message: ReactNode
    variant?: NotificationVariant
    dismissable?: boolean
    hideIcon?: boolean
    customIcon?: React.ReactNode
    onRemove?: (id: string) => void
}
